import { toBoolean } from '../../../../core/utils/lp-backend';
import { writeConfigFields } from './settings-fields';

/** `PATCH /client/config/fields`: root `sms_enabled`. */
export const editSms = async (sms_enabled: boolean): Promise<any> =>
  writeConfigFields({ sms_enabled: toBoolean(sms_enabled) });
